// The create-from-template endpoints answer 201 even when booking the
// production into the ERP failed (the local production is kept), and report
// that in `erp: {ok, error?, docId?, skipped?}`. This pulls out what a
// warning needs, or null when there is nothing to warn about.
export const erpFailure = (erp) => {
  if (!erp || erp.ok !== false) return null;
  return {
    error: erp.error || 'unknown error',
    doc: erp.docId ? ` [ERP doc ${erp.docId}]` : '',
  };
};
